import React from 'react';
import { useToggleState } from '@cian/react-utils';
import { useDeviceType } from '@cian/ui-kit';
import { useSelector, useDispatch } from 'react-redux';

import { CallToActionCard } from '../../components/CallToActionCard';
import { CallToActionCardLayout } from '../../components/CallToActionCardLayout';
import { selectDealSaleB2bPromoUrl } from '../../selectors/links';
import { ShareWithRealtorModalContainer } from '../ShareWithRealtorModalContainer';
import { pipe } from '../../utils/pipe';
import { trackChoseRealtorClick, trackTellRealtorClick } from './tracking';
import { openLeaveContactsModal } from '../../actions/leaveContacts/actions';

export const SHARE_LINK_TEXT = 'Приглашение провести Циан.Сделку';

export const CallToActionContainer = () => {
  const dispatch = useDispatch();
  const onOpenLeaveContactsModal = () => dispatch(openLeaveContactsModal());

  const { state: isShareWithRealtorModalOpened, toggle: toggleShareWithRealtorModalOpened } = useToggleState();
  const isMobile = useDeviceType() === 'phone';
  const b2bPromoUrl = useSelector(selectDealSaleB2bPromoUrl);

  const onShareWithRealtorClick = () => {
    const shareObject: ShareData = {
      text: `${SHARE_LINK_TEXT}\n`,
      url: b2bPromoUrl,
    };
    if (isMobile && typeof window.navigator.canShare === 'function' && window.navigator.canShare(shareObject)) {
      window.navigator.share(shareObject);
    } else {
      toggleShareWithRealtorModalOpened();
    }
  };

  return (
    <>
      <CallToActionCardLayout>
        <CallToActionCard
          imageX1Src="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/boy_x1.png"
          imageX2Src="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/boy_x2.png"
          heading="Я уже работаю с риелтором"
          description="Расскажите ему о нашей услуге и пригласите провести регистрацию собственности с Циан."
          buttonText="Рассказать риелтору"
          onClick={pipe(trackTellRealtorClick, onShareWithRealtorClick)}
        />
        <CallToActionCard
          imageX1Src="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/magnifying_glass_x1.png"
          imageX2Src="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/magnifying_glass_x2.png"
          heading="Я ещё не подобрал риелтора"
          description="Оставьте свой номер телефона, и мы подберём вам риелтора для проведения сделки."
          buttonText="Выбрать риелтора на Циан"
          onClick={pipe(trackChoseRealtorClick, onOpenLeaveContactsModal)}
        />
      </CallToActionCardLayout>
      <ShareWithRealtorModalContainer
        open={isShareWithRealtorModalOpened}
        onClose={toggleShareWithRealtorModalOpened}
      />
    </>
  );
};
